import React from 'react';
import device from 'common/support/device';
import styles from './AriaTextToSpeech.module.scss';

const AriaTextToSpeech = () => {
  return (
    device.useAriaAccessibility && (
      <>
        <div
          className={styles.ariaHidden}
          id="aria-hidden-1"
          role="presentation"
          tabIndex={"-1" as unknown as number}
        />
        <div
          className={styles.ariaHidden}
          id="aria-hidden-2"
          role="presentation"
          tabIndex={"-1" as unknown as number}
        />
        <div
          className={styles.ariaHidden}
          id="aria-hidden-stop"
          aria-label=""
          role="presentation"
          tabIndex={"-1" as unknown as number}
        />
      </>
    )
  );
};

export default AriaTextToSpeech;
